import React, { Component } from 'react';
import { Fstyr } from '../../components/FstyrComponents/Fstyr.js';
import { fetchModel } from '../../components/HelperComponents/FetchExtension';
import { DateFormatter } from '../../components/HelperComponents/DateFormatter.ts'
import URL from '../../Constants/URL'
import { WorkshopCardVm } from '../../Models/WorkshopCardVm';
import { PersonVm } from '../../Models/PersonVm';
import { GetStatusName } from '../../components/HelperComponents/StatusHelper';
import { formatAuthorizationNumber, sortCardTableByDate } from '../../components/HelperComponents/Helpers';
import { ValidationType } from '../../Constants/ValidationTypes.ts';
import { formatAddress } from '../../components/HelperComponents/AddressFormatter.js';

export class SearchWorkShopCPR extends Component {
  static displayName = SearchWorkShopCPR.name;

  constructor(props) {
    super(props);
    this.toast = React.createRef();
    this.state = {
      showSpinner: false,
      cprInput: "",

      //Button press
      searchButtonPressed: false,

      //Validation
      cprInputIsValid: false,

      personVm: new PersonVm(),
      workshopCards: [],

    };
  }

  fetchWorkshopcards() {
    this.setState({ searchButtonPressed: true })
    if (this.state.cprInputIsValid) {
      this.clearPage(false);
      this.setState({ showSpinner: true })
      fetchModel("GET", URL + "/api/WorkshopCard/GetWorkshopCardsWithCpr", this.state.cprInput, WorkshopCardVm)
        .then(model => {
          this.handleWorkshopSearchResults(model)
        })
        .catch(error => {
          this.showErrorToast(error)
        })
    }
  }
  
  handleWorkshopSearchResults(result) {
    let results = []
    result = sortCardTableByDate(result)
    for (let i = 0; i < result.length; i++) {
      results.push([
        result[i].CardNumber,
        result[i].Cvr,
        formatAuthorizationNumber(result[i].AuthorizationNumber),
        result[i].Person.FirstName,
        result[i].Person.LastName,
        DateFormatter(result[i].ValidFrom),
        DateFormatter(result[i].ValidTo),
        GetStatusName(result[i].Status.Id)
      ])
    }

    this.setState({
      personVm: result[0].Person,
      workshopCards: results,
      showSpinner: false
    })
  }

  clearPage(clearInput) {
    if (clearInput) {
      this.setState({
        cprInput: "",
        searchButtonPressed: false,
        cprInputIsValid: false,
      })
    }

    this.setState({
      showSpinner: false,

      PersonVm: new PersonVm(),
      workshopCards: [],
    })
  }

  showErrorToast(error) {
    this.setState({ showSpinner: false })
    if (error === "No result") {
      this.toast.current.show("Værkstedskort", "Der findes ikke et værkstedskort med det søgte CPR nummer", "warning")
    }
    else if (error === "Failed response") {
      this.toast.current.show("Fejl", "Kan ikke forbinde til databasen", "error")
    }
    else {
      this.toast.current.show("Fejl", "Der skete en ukendt fejl", "error")
    }
  }

  render() {
    return (
      <div>
        <Fstyr.Toast ref={this.toast} />
        <Fstyr.Segment
          title="Søg Værkstedskort"
          isPageTitle={true}
        >
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button
              label="Ryd side"
              onClick={() => { this.clearPage(true) }}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Angiv CPR"
        >
          <Fstyr.Input
            value={this.state.cprInput}
            label="CPR nummer"
            direction={"col"}
            onChange={(value) => this.setState({ cprInput: value })}
            validation={true}
            validationType={ValidationType.cpr}
            errorBodyText={"Forkert format (10 tal)"}
            errorExampleText={"f.eks. 1234567890"}
            onEnterPressed={() => this.fetchWorkshopcards()}
            setValid={(valid) => this.setState({ cprInputIsValid: valid })}
            buttonClicked={this.state.searchButtonPressed}
            onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
          />

          <div className="fstyr-left-button-group">
            <Fstyr.Button
              label="Søg"
              onClick={() => {
                this.fetchWorkshopcards()
              }}
              disabled={this.state.showSpinner}
            />
            <div style={{ width: 20 }} />
            <Fstyr.Spinner
              show={this.state.showSpinner}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Mekanikerinformation"
        >
          <div>
            <div className="fstyr-attention-box">
              <Fstyr.Input
                label="CPR"
                readonly={true}
                value={this.state.personVm.Cpr}
                direction="row"
              />
              <Fstyr.Input
                label="Fornavn"
                readonly={true}
                value={this.state.personVm.FirstName}
                direction="row"
              />
              <Fstyr.Input
                label="Efternavn"
                readonly={true}
                value={this.state.personVm.LastName}
                direction="row"
              />
              <Fstyr.Input
                label="Adresse"
                readonly={true}
                value={formatAddress(this.state.personVm.Address, true)}
                direction="row"
              />
            </div>
          </div>
          <Fstyr.SelectableTable
            label="Registreret værkstedskort"
            headers={["Kortnr.", "CVR", "Autorisationsnummer", "Fornavn", "Efternavn", "Startdato", "Udløbsdato", "Status"]}
            data={this.state.workshopCards === [] ? null : this.state.workshopCards}
            note={"Mekaniker har " + this.state.workshopCards.length + " registreringer på værkstedskort"}
            path={"workshopCard"}
            disableAll={true}
            useLinks={true}
          />
        </Fstyr.Segment>

      </div>
    );
  }
}
